<!--
 * @Author: QWX
 * @Description:主订单列表
 * @LastEditors: QWX
 * @LastEditTime: 2021-12-30 15:59:46
-->
<template>
  <el-card class="order-choosen">
    <div slot="header" class="">
      <span class="saas-card-header-name" >主订单</span>
    </div>
    <div class="">
      <zl-server-page-table
        :border="false"
        ref="listDetailTable"
        :api="getApi"
        smallPagination
        :columns="columns"
        paginationLayout="total, sizes, prev, pager, next, jumper"
      >
      </zl-server-page-table>
    </div>
    <orderDetailDrawer ref="orderDetailDrawer"/>
  </el-card>
</template>

<script>
import { getValue } from '@/lib/enum'
import orderDetailDrawer from '@/components/reconciliationAndSettlement/orderDetailDrawer.vue'
import dayjs from 'dayjs'
export default {
  components: { orderDetailDrawer },
  props: {
    id: {
      type: String,
      default: '',
      require: true
    },
    supplierCorp: {
      type: String,
      default: '',
      require: true
    }
  },
  data() {
    return {
      getValue,
      dayjs,
      //   主订单表头
      columns: [
        {
          label: '序号',
          prop: 'rowNum',
          width: '100px',
          align: 'center'
        },
        {
          label: '订单名称',
          prop: 'orderName',
          minWidth: '100px',
          align: 'center',
          render: (h, row) => (
            <el-link type='primary' on-click={() => this.$refs.orderDetailDrawer.open(row.id)}>{row.orderName}</el-link>
          )
        },
        {
          label: '订单编号',
          prop: 'orderCode',
          minWidth: '100px',
          align: 'center'
        },
        {
          label: '订单种类',
          prop: 'orderCategory',
          align: 'center',
          formatter: (row) => getValue('orderCategory', row.orderType)
        },
        {
          label: '下单时间',
          prop: 'releaseTime',
          align: 'center',
          formatter: (row) => row.releaseTime &&
            dayjs(row.releaseTime).format('YYYY-MM-DD HH:mm:ss')
        },
        {
          label: '采购单位',
          prop: 'purchaseName',
          align: 'center'
        },
        {
          label: '订单预算金额',
          prop: 'purchaseName',
          align: 'center'
        },
        {
          label: '申请开票时订单实际付款（元）',
          prop: 'orderPay',
          align: 'center'
        },
        {
          label: '申请开票最终结算金额（元）',
          prop: 'subOrderPay',
          align: 'center'
        },
        {
          label: '币种',
          prop: 'currencyCH',
          align: 'center'
        }
      ]
    }
  },
  methods: {
    /**
     * @description: 验收后退换货详情
     * @param {*} args
     */
    getApi(args) {
      const api = this.$store.state.system === 'purchaser' ? 'pageOrderForInvoiceView' : 'pageOrderForInvoiceViewGys'
      return this.$store.dispatch(api, {
        invoiceId: this.id,
        supplierCorp: this.supplierCorp,
        pageNum: args.page,
        pageSize: args.size
      }).then((res) => {
        return {
          rows:
            // 后端可能返回null
            (res.list || []).map((t, index) => ({
              ...t,
              // 后端不提供行号,此处手动计算
              rowNum: args.size * (args.page - 1) + index + 1
            })) || [],
          total: res.totalCount
        }
      })
    },
    openMainOrder(id) {
      this.$refs.orderDetailDrawer.open(id)
    }
  }
}
</script>
<style lang="scss" scoped>
.order-choosen{
   .super-budge{
      display: inline-block;
      height: 20px;
      padding: 0 5px;
      vertical-align: middle;
      text-align: center;
      line-height: 18px;
      border-radius: 10px;
      border: 1px solid #FF473C;
      font-size: 12px;
      color: #FF473C;
      transform: scale(0.9);
   }
   .order-choosen-bottom{
      margin-top: 32px;
      border-top: 1px dashed rgba(0, 0, 0, 0.11);
      padding-top: 32px;
   }
   .order-choosen-footer{
     height: 48px;
     width: calc(100% + 40px);
     margin-left: -20px;
     margin-bottom: -20px;
     padding:0 24px 0 0;
     line-height: 48px;
     text-align: right;
     box-sizing: border-box;
     box-shadow: 0px -2px 4px 0px rgba(4, 46, 111, 0.05);
      border-radius: 0px 0px 8px 8px;
      p{
        padding: 0;
        margin: 0;
      }
   }
   ::v-deep.zl-page-table .pagination-container{
      text-align: right;
   }
}
</style>
